import React, { useState, useEffect } from 'react';
import { Layout, theme } from 'antd';
// import Skill from '../employee';
import styles from './styles.module.scss';
import SkillListHeader from '../skill-list-header';
import Skill from '../skill';

const { Content } = Layout;
interface SkillListProps {
  skillList: any;
}
const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const SkillList: React.FC<SkillListProps> = ({
  skillList,
}: SkillListProps): JSX.Element => {
  console.log(skillList);
  return (
    <>
      <Layout className={styles.layout}>
        <Content className={styles.container}>
          <div style={{ minWidth: '1000px' }}>
            <SkillListHeader />
            {skillList.map((skill: any, index: number) => {
              return (

                <Skill {...{ skill: skill }} key={index} />

              );
            })}
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default SkillList;
